import { Box, IconButton, useTheme } from "@mui/material";

import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../theme";
import BaseCard from "../../../theme/cards/BaseCard";
import CardLabel from "../../../theme/label/CardLabel";
import TopRight from "../../../theme/positionals/TopRight";
import ShDoubleTextSkeleton from "../../../theme/skeleton/ShDoubleTextSkeleton";
import Text from "../../../theme/text/Text";
import ShTextSkeleton from "../../../theme/skeleton/ShTextSkeleton";

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { getWarehouseLocationLabelData } from "../../../../utils/labelColorText";
import { generateColorFromTitle, generateIconColorFromTitle } from "../../../theme/TabView3/IconColorGenerator";

const WarehousePickingCartCard = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    let backGround = generateColorFromTitle(props.reachType?.description, theme.palette.mode, 93)
    let foreGround = generateIconColorFromTitle(props.reachType?.description, theme.palette.mode)

    return (
        <BaseCard onClick={props.onClick}>
            <Box>
                <Box>
                    <Box>
                        <Text semibold>{props.barcode}</Text>
                    </Box>

                    <TopRight>
                        <Box
                            sx={{
                                height:32,
                                px:2,
                                display:"flex",
                                alignItems:'center',
                                fontFamily:"Roboto, sans-serif",
                                fontSize:14,
                                color:foreGround,
                                background:backGround,
                                borderTopRightRadius:12,
                                borderBottomLeftRadius:12,
                                borderBottomRightRadius:6,
                                borderTopLeftRadius:6,
                                fontWeight:500,
                            }}
                        >
                            {props.reachType?.description}
                        </Box>

                    </TopRight>

                    <Box marginTop={2}>

                        <Box
                            sx={{
                                display:'flex',
                                flexDirection:"column"
                            }}
                        >
                            <Text light>{t("locations")}</Text>
                            {props.skeleton ?
                                <ShTextSkeleton/> 
                                :
                                <Text>
                                    {props.pickupCartLocations?.length}
                                </Text>
                            }
                        </Box>
                    </Box>
                </Box>
            </Box>
        </BaseCard>
    )
}

export default WarehousePickingCartCard;

export const WarehousePickingCratesCard = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    let backGround = generateColorFromTitle(props.containerSize?.description ?? "-", theme.palette.mode, 93)
    let foreGround = generateIconColorFromTitle(props.containerSize?.description ?? "-", theme.palette.mode)

    return (
        <BaseCard onClick={props.onClick}>
            <Box>
                <Box>
                    <Box>
                        <Text semibold>{props.barcode}</Text>
                    </Box>

                    <TopRight>
                        <Box
                            sx={{
                                height:32,
                                px:2,
                                display:"flex",
                                alignItems:'center',
                                fontFamily:"Roboto, sans-serif",
                                fontSize:14,
                                color:foreGround,
                                background:backGround,
                                borderTopRightRadius:12,
                                borderBottomLeftRadius:12,
                                borderBottomRightRadius:6,
                                borderTopLeftRadius:6,
                                fontWeight:500,
                            }}
                        >
                            {props.containerSize?.description}
                        </Box>

                    </TopRight>

                    <Box 
                        sx={{
                            mt:2,
                            display:"flex",
                            gap:3,
                        }}
                    >

                        <Box
                            sx={{
                                display:'flex',
                                flexDirection:"column"
                            }}
                        >
                            <Text light>{t("dimensions_lwh")}</Text>
                            {props.skeleton ?
                                <ShTextSkeleton/> 
                                :
                                <Text>{`${props.containerSize?.length}mm x ${props.containerSize?.width}mm x ${props.containerSize?.height}mm`}</Text>
                                
                            }
                        </Box>
                        <Box
                            sx={{
                                display:'flex',
                                flexDirection:"column"
                            }}
                        >
                            <Text light>{t("volume")}</Text>
                            {props.skeleton ?
                                <ShTextSkeleton/> 
                                :
                                <Box>
                                    <Text sx={{marginRight:0.5}}>{props.containerSize?.volume}</Text>
                                    <Text light>{t("mm3")}</Text>
                                </Box>
                                
                            }
                        </Box>
                    </Box>
                </Box>
            </Box>
        </BaseCard>
    )
}


export const WarehousePickingCrateSizeCard = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    let backGround = generateColorFromTitle(props.description ?? "-", theme.palette.mode, 93)
    let foreGround = generateIconColorFromTitle(props.description ?? "-", theme.palette.mode)

    return (
        <BaseCard onClick={props.onClick}>
            <Box>
                <Box>
                    <Box>
                        <Text semibold>{props.description}</Text>
                    </Box>

                    <TopRight>
                        <Box
                            sx={{
                                height:32,
                                px:2,
                                display:"flex",
                                alignItems:'center',
                                fontFamily:"Roboto, sans-serif",
                                fontSize:14,
                                color:foreGround,
                                background:backGround,
                                borderTopRightRadius:12,
                                borderBottomLeftRadius:12,
                                borderBottomRightRadius:6,
                                borderTopLeftRadius:6,
                                fontWeight:500,
                            }}
                        >
                            {props.description}
                        </Box>

                    </TopRight>

                    <Box 
                        sx={{
                            mt:2,
                            display:"flex",
                            gap:3,
                        }}
                    >

                        <Box
                            sx={{
                                display:'flex',
                                flexDirection:"column"
                            }}
                        >
                            <Text light>{t("dimensions_lwh")}</Text>
                            {props.skeleton ?
                                <ShTextSkeleton/> 
                                :
                                <Text>{`${props.length}mm x ${props.width}mm x ${props.height}mm`}</Text>
                                
                            }
                        </Box>
                    </Box>
                </Box>
            </Box>
        </BaseCard>
    )
}